import { type GenericError, type GetTokenSilentlyOptions, useAuth0 } from '@auth0/auth0-react';
import { useCallback } from 'react';

export const useAccessToken = () => {
  const { getAccessTokenSilently: auth0GetAccessTokenSilently, loginWithRedirect } = useAuth0();

  const getAccessTokenSilently = useCallback(
    async (options?: GetTokenSilentlyOptions) => {
      try {
        return await auth0GetAccessTokenSilently(options);
      } catch (error: unknown) {
        const err = error as GenericError;

        if (err.error === 'login_required') {
          // Redirect to login if the user is not authenticated
          await loginWithRedirect({
            appState: {
              returnTo: window.location.pathname + window.location.search,
            },
          });

          return '';
        }

        throw error;
      }
    },
    [auth0GetAccessTokenSilently, loginWithRedirect],
  );

  return {
    getAccessTokenSilently,
  };
};
